import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Transition } from 'transition-group';

import ModalSwitcher from 'components/ModalSwitcher';
import { Page, Screen } from 'components/Common';
import Navigation from 'components/Navigation';

import {
  iOSNavbarHeight,
  androidNavbarTopRowHeight,
  androidNavbarHeight
} from 'themes';
import { isiOS } from 'config';

export default class Layout extends Component {
  static propTypes = {
    backText: PropTypes.string,
    backNavigate: PropTypes.func,
    center: PropTypes.string,
    scrollKey: PropTypes.string
  };

  state = {
    scrolling: false,
    top: 0
  };

  onScroll = ({ scrolling = false, top = 0 }) => {
    if (isiOS && this.state.scrolling === scrolling) {
      return;
    }
    if (top > androidNavbarTopRowHeight) {
      top = androidNavbarTopRowHeight;
    }
    if (this.state.scrolling === scrolling && this.state.top === top) {
      return;
    }
    this.setState({
      scrolling,
      top
    });
  };

  render() {
    const {
      tabs,
      pageElement,
      backText,
      backNavigate,
      center,
      right,
      direction,
      name,
      scrollKey,
      navbarContent
    } = this.props;
    const { scrolling, top } = this.state;

    let navbarHeight = iOSNavbarHeight;
    if (!isiOS) {
      navbarHeight = tabs
        ? androidNavbarHeight({ top })
        : `${androidNavbarTopRowHeight}px`;
    }

    let NavigationEl = (
      <Navigation
        scrolling={scrolling}
        backText={backText}
        backNavigate={backNavigate}
        center={center}
        right={right}
        top={top}
        tabs={tabs}
      >
        {navbarContent}
      </Navigation>
    );

    let PageEl = (
      <Page
        onScroll={this.onScroll}
        navbarHeight={navbarHeight}
        scrollKey={scrollKey}
      >
        {pageElement}
      </Page>
    );

    if (isiOS && direction !== 'slide-left' && direction !== 'slide-right') {
      NavigationEl = (
        <Transition key={`${name}-nav`} className={`nav-${direction}`}>
          {NavigationEl}
        </Transition>
      );
      PageEl = (
        <Transition key={`${name}-page`} className={direction}>
          {PageEl}
        </Transition>
      );
    }

    return (
      <Screen className="screen">
        <ModalSwitcher />
        {NavigationEl}
        {PageEl}
      </Screen>
    );
  }
}
